<template>
  <div>
    <navbar class="fixed-top" v-model="showNavbar" :transparent="navbarTransparent">
      <template slot="navbar-menu-l">
        <div class="logo">
          <a class="" aria-label="logo" href="https://www.fnmotol.cz/">
            <div style="padding: 20px 40px">
                <img src="/img/logo_motol.png" alt="">
            </div>
          </a>
        </div>

        <div class="app_name"> {{ application }}
          <span class="app_name_small"> &nbsp;&nbsp;&nbsp;(v. 0-3-6)</span>
        </div>

      </template>

      <template slot="navbar-menu">
        <!-- <form v-if="token > ''">
          <div class="input-group no-border">
            <input type="text" value="" class="form-control" placeholder="Search...">
            <div class="input-group-append">
              <div class="input-group-text">
                <i class="fas fa-search"></i>
              </div>
            </div>
          </div>
        </form> -->

        <ul class="navbar-nav dolu_subject">
          <li class="nav-item">
            <router-link class="nav-link btn-magnify" to="/welcome">
              <p>
                ÚVOD
              </p>
            </router-link>
          </li>

          <li class="nav-item" v-if="token > ''">
            <router-link class="nav-link" to="/patients">
              <p>
                PACIENTI
              </p>
            </router-link>
          </li>

          <drop-down v-if="token > ''" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
            <a slot="title"
              slot-scope="{isOpen}"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="isOpen">
              <p style="padding-right: 5px;">
                NASTAVENÍ
              </p>
            </a>
            <router-link tag="li" class="dropdown-item" to="/users"> Uživatelé </router-link>
            <router-link tag="li" class="dropdown-item" to="/adsettings"> Správa číselníků </router-link>
          </drop-down>

          <li class="nav-item">
            <a class="nav-link">
              <p @click="open_modal_help">
                PODPORA
              </p>
            </a>
          </li>

          <li class="nav-item" v-if="token > ''">
          </li>

          <drop-down v-if="!token" tag="li" position="right" direction="none" class="nav-item">
            <a slot="title"
              slot-scope="{isOpen}"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="isOpen"
              >
              <p style="padding-right: 5px; color: #6bdf8e;" @click="m_modal_login(true)">
                PŘIHLÁŠENÍ
              </p>
            </a>
          </drop-down>

          <drop-down v-if="token" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown">
            <a slot="title"
              slot-scope="{isOpen}"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="isOpen"
              >
              <p style="padding-right: 5px; color: #6bdf8e;">
                {{loginuser.f_name}} {{loginuser.l_name}}
              </p>
            </a>
            <a class="dropdown-item" @click="m_modal_password_change(true)"> Změnit heslo </a>
            <a class="dropdown-item" @click="a_logout()"> Odhlásit </a>
          </drop-down>

        </ul>
      </template>

    </navbar>

    <el-dialog :visible.sync="modal_help" title="Uživatelská podpora" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="false" width="1000px" center :close-on-click-modal="false" :close-on-press-escape="false">

        <el-row>
          <el-col>
            <h5 class="modal_dark_blue title-1">Dotazy k aplikační podpoře</h5>
            <div class="card-modal white">
              <el-collapse v-model="activeNamesHelp" @change="collapshelp">
                <el-collapse-item  title="Jak mohu získat svůj uživatelský účet?" name="1" class="hlp">
                  <el-row>
                    <el-col :span="24">
                      <p>Pro zavedení Vašeho uživatelského účtu kontaktujte administrátora aplikace NEON.
                        Jakmile budete přidáni administrátorem do seznamu uživatelů a bude Vám přiřazena role, obdržíte e-mailem odkaz pro automatické přihlášení do aplikace.
                        Posledním krokem je vyplnění a potvrzení Vašeho uživatelského hesla. Nezapomeňte, že uvedený e-mail je zároveň Vaším uživatelský jménem.
                        Na tuto e-mailovou adresu budou také zasílány systémové zprávy z aplikace.</p>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="activeNamesHelp" @change="collapshelp">
                <el-collapse-item  title="Jaká práva mají uživatelé podle přidělených rolí?"  name="2" class="hlp">
                  <el-row>
                    <el-col :span="24">
                      <p>GUEST - má oprávnění pouze pro nahlížení do aplikace.</p>
                      <p>EDITOR - má oprávnění <b>PŘIDÁVAT/EDITOVAT</b> pacienta. Pro smazání pacienta kontaktujte ADMINISTRÁTORA. Dále má editor oprávnění <b>PŘIDÁVAT/EDITOVAT/MAZAT</b> v sekci <i>Diagnóza/událost, Operace, Kontroly, Léčba</i>. Také může <b>PŘIDÁVAT/EDITOVAT/MAZAT</b> položky v sekci <i>Správa číselníků.</i></p>
                      <p>ADMINISTRÁTOR - má oprávnění <b>MAZAT</b> pacienta, <b>PŘIDÁVAT</b> nového uživatele a zároveň může mít všechna práva editora.</p>
                      <p>Informace o přiřazené roli jednotlivých uživatelů je dostupná v menu <i>Nastavení/Uživatelé</i>.</p>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="activeNamesHelp" @change="collapshelp">
                <el-collapse-item  title="Zapomenuté heslo?" name="3" class="hlp">
                  <el-row>
                    <el-col :span="24">
                      <p>Heslo si volí uživatel aplikace sám. Pokud jste již zavedený uživatel a heslo nemáte nebo jste ho zapomněli, můžete si nechat poslat nový link pro přihlášení.
                        V menu <i>Přihlášení</i> zvolíte volbu <i>Zapomenuté heslo?</i> a po vyplnění Vašeho e-mailu (musí být shodný s e-mailem pro přihlašování) Vám bude zaslán link pro
                        automatické přihlášení a zadání nového hesla.
                      </p>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="activeNamesHelp" @change="collapshelp">
                <el-collapse-item  title="Změna hesla" name="4" class="hlp">
                  <el-row>
                    <el-col :span="24">
                      <p><b>Přihlášený</b> uživatel si může v menu <i>Přihlášení/Změnit heslo</i> změnit stávající uživatelské heslo za nové.
                      </p>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <h5 class="modal_dark_blue title-1 pt-10">Nový dotaz</h5>
            <div class="card-modal white">
              <el-form ref="form_help" :rules="rules_help" :model="form_help">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> E-mail</div>
                    <el-form-item prop="email">
                      <el-input placeholder="Zadejte Váš e-mail" v-model="form_help.email" class="mb-10"></el-input>
                    </el-form-item>
                    <div class="modal_label dark_grey">Předmět</div>
                    <el-form-item prop="subject">
                      <el-input placeholder="Předmět" v-model="form_help.subject" class="mb-10"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Dotaz</div>
                    <el-form-item prop="dotaz">
                      <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="Napište svůj dotaz"
                        v-model="form_help.dotaz">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="20" >
                      <el-col :span="24">
                        <div><span class="modal_label dark_green">*</span> <i>povinné údaje</i></div>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <div class="text-center mt-3">
                  <el-button native-type="button" class="btn-green-big" @click="modal_help_send" size="mini"><i class="el-icon-finished"></i> ODESLAT</el-button>
                  <el-button class="btn-blue" link @click.native="modal_help_close" slot="footer" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
                </div>
              </el-form>
            </div>
          </el-col>
        </el-row>


    </el-dialog>


    <el-dialog :visible.sync="modal_login" title="Přihlášení" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="false" width="400px" center :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form_login" :rules="rules_login" :model="form_login">
        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> E-mail</div>
        <el-form-item prop="email">
          <el-input placeholder="Zadejte Váš e-mail" v-model="form_login.email" class="mb-10"></el-input>
        </el-form-item>
        <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Heslo</div>
        <el-form-item prop="password">
          <el-input placeholder="Zadejte Vaše heslo" v-model="form_login.password" show-password @keyup.native.enter="a_login(form_login)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" native-type="button" slot="footer" @click.native="modal_go_to_forgot_password"> Zapomenuté heslo? </el-button><br>
        <el-button native-type="button" slot="footer" class="btn-green-big" @click="a_login(form_login)" size="mini"><i class="el-icon-finished"></i> PŘIHLÁSIT </el-button>
        <el-button class="btn-blue" link @click.native="modal_login_close" slot="footer" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="modal_password_new" title="Nové heslo" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="false" center :close-on-click-modal="false" :close-on-press-escape="false" @close="modal_password_new_close">
      <el-form ref="form_password_new" size="mini" :rules="rules_password_change" :model="password_change">
        <el-row>
          <el-col>
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Heslo poprvé</div>
            <el-form-item prop="password_a">
              <el-input type="password"
                        placeholder=""
                        v-model="password_change.password_a"
                        size="small"
                        :show-password="true"
                        >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <div class="modal_label dark_grey mt-10"><span class="modal_label dark_green">*</span> Heslo podruhé</div>
            <el-form-item prop="password_b">
              <el-input type="password"
                        placeholder=""
                        v-model="password_change.password_b"
                        size="small"
                        :show-password="true"
                        @keyup.native.enter="click_password_new()"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button native-type="button" slot="footer" class="btn-green-big" @click="click_password_new()" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
        <el-button class="btn-blue" link @click.native="modal_password_new_close" slot="footer" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="modal_password_change" title="Změna hesla" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="false" center :close-on-click-modal="false" :close-on-press-escape="false" @close="modal_password_change_close">
      <el-form ref="form_password_change" size="mini" :rules="rules_password_change" :model="password_change">
        <el-row>
          <el-col>
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Heslo poprvé</div>
            <el-form-item prop="password_a">
              <el-input type="password"
                        placeholder=""
                        v-model="password_change.password_a"
                        size="small"
                        :show-password="true"
                        >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <div class="modal_label dark_grey mt-10"><span class="modal_label dark_green">*</span> Heslo podruhé</div>
            <el-form-item prop="password_b">
              <el-input type="password"
                        placeholder=""
                        v-model="password_change.password_b"
                        size="small"
                        :show-password="true"
                        @keyup.native.enter="click_password_change()"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button native-type="button" slot="footer" class="btn-green-big" @click="click_password_change()" size="mini"><i class="el-icon-finished"></i> ZMĚNIT </el-button>
        <el-button class="btn-blue" link @click.native="modal_password_change_close" slot="footer" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="modal_password_forgot" title="Zapomenuté heslo" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="false" center :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form_password_forgot" size="mini" :rules="rules_password_forgot" :model="password_forgot">
        <el-row>
          <el-col>
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Vaše e-mailová adresa</div>
            <el-form-item prop="email">
              <el-input type="text"
                        placeholder=""
                        v-model="password_forgot.email"
                        size="small"
                        @keyup.native.enter="modal_password_forgot_send"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button class="btn-green-big" link @click.native="modal_password_forgot_send" size="mini"><i class="el-icon-message"></i> ODESLAT </el-button>
            <el-button class="btn-blue" link @click.native="modal_password_forgot_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();
    }, 66);
  }
}

  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
  import {Select, Option, Tag, Menu } from 'element-ui'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import axios from 'axios';
  import VueNotify from 'vue-notifyjs'
  import VueRouter from 'vue-router'

  export default {
    components: {
      Navbar,
      NavbarToggleButton,
      [Select.name]: Select,
      [Option.name]: Option,
      [Tag.name]: Tag,
      [Menu.name]: Menu,
    },
    data() {
      return {
        activeNotifications: true,
        showNavbar: false,
        navbarTransparent: true,

        form_help: {
          email: "",
          subject: "",
          dotaz: "",
        },

        form_login: {
          email: "",
          password: "",
        },

        password_change: {
          password_a: "",
          password_b: "",
        },

        password_forgot: {
          email: "",
        },

        activeNamesHelp: [''],

        rules_help: {
          email: [
            { required: true, message: 'Položka je vyžadována.', trigger: 'blur' },
            { type: "email", message: 'Zkontrolujte prosím položku e-mail.', trigger: 'blur' }
          ],
          dotaz: [
            { required: true, message: 'Položka je vyžadována.', trigger: 'blur' }
          ],
        },

        rules_login: {
          email: [
            { required: true, message: 'Položka je vyžadována.', trigger: 'blur' },
            { type: "email", message: 'Zkontrolujte prosím položku e-mail.', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Heslo je vyžadováno', trigger: 'blur' },
          ],
        },

        rules_password_change: {
          password_a: [
            { required: true, message: 'Heslo je vyžadováno', trigger: 'blur' },
          ],
          password_b: [
            { required: true, message: 'Heslo je vyžadováno', trigger: 'blur' },
          ],
        },

        rules_password_forgot: {
          email: [
            { required: true, message: 'Položka je vyžadována.', trigger: 'blur' },
            { type: "email", message: 'Zkontrolujte prosím položku e-mail.', trigger: 'blur' }
          ],
        },

      }
    },

    computed: {
      ...mapState({
        modal_login: state => state.modal_login,
        modal_reg: state => state.modal_reg,
        id_user: state => state.id_user,
        token: state => state.token,
        id_subject: state => state.id_subject,
        loginuser: state => state.loginuser,
        subject: state => state.subject,
        application: state => state.application,
        apps: state => state.apps,
        app: state => state.app,

      }),

      ...mapGetters({

      }),

      modal_login: {
        get() { return this.$store.state.modal_login; },
        set(value) { this.$store.commit('m_modal_login', value); }
      },

      modal_password_new: {
        get() { return this.$store.state.modal_password_new; },
        set(value) { this.$store.commit('m_modal_password_new', value); }
      },

      modal_password_change: {
        get() { return this.$store.state.modal_password_change; },
        set(value) { this.$store.commit('m_modal_password_change', value); }
      },

      modal_password_forgot: {
        get() { return this.$store.state.modal_password_forgot; },
        set(value) { this.$store.commit('m_modal_password_forgot', value); }
      },

      modal_help: {
        get() { return this.$store.state.modal_help; },
        set(value) { this.$store.commit('m_modal_help', value); }
      },


    },

    methods: {
      ...mapMutations({
        m_modal_help: 'm_modal_help',
        m_modal_login: 'm_modal_login',
        m_modal_reg: 'm_modal_reg',
        m_modal_password_forgot: 'm_modal_password_forgot',
        m_modal_password_change: 'm_modal_password_change',
        m_modal_password_new: 'm_modal_password_new',
        m_token: 'm_token',
        m_id_user: 'm_id_user',
        m_app: 'm_app',

      }),


      ...mapActions({
        a_help: 'a_help',
        a_login: 'a_login',
        a_logout: 'a_logout',
        a_forgot: 'a_forgot',
        a_test: 'a_test',
        a_join_subject: 'a_join_subject',
        a_password_change: 'a_password_change',


      }),

      modal_help_close() {
        this.m_modal_help(false);
        this.$refs["form_help"].resetFields();
      },

      modal_help_send() {
        this.a_help( {"email": this.form_help.email, "subject": this.form_help.subject, "dotaz": this.form_help.dotaz } );
        this.m_modal_help(false);
        this.$refs["form_help"].resetFields();
      },


      modal_login_close() {
        this.m_modal_login(false);
        this.$refs["form_login"].resetFields();
      },


      modal_go_to_forgot_password() {
        this.m_modal_login(false);
        this.password_forgot.email = this.form_login.email;
        this.m_modal_password_forgot(true);
      },


      modal_password_forgot_send() {
        this.a_forgot( {forgot_email: this.password_forgot.email} );
        this.$refs["form_password_forgot"].resetFields();
      },


      modal_password_forgot_close() {
        this.m_modal_password_forgot(false);
        this.$refs["form_password_forgot"].resetFields();
      },


      modal_password_change_close() {
        this.m_modal_password_change(false);
        this.$refs["form_password_change"].resetFields();
      },

      modal_password_new_close() {
        this.m_modal_password_new(false);
        this.$refs["form_password_new"].resetFields();
      },


      click_password_change() {
        if (this.password_change.password_a != "" && this.password_change.password_a != this.password_change.password_b) {
          this.$alert('Hesla nejsou identická. Opakujte zadání hesla znovu.', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true
            });
            return false;
        } else {
            this.$refs["form_password_change"].validate((valid) => {
            if (valid) {
              this.a_password_change( { new_password: this.password_change.password_a} );
              this.m_modal_password_change(false);
              this.m_modal_password_new(false);
              // this.password_change.password_a = "";
              // this.password_change.password_b = "";
            } else {
              this.$message({ type: 'error', message: 'Formulář nelze odeslat, ověřte položky!' });
              return false;
            }
          });
        }

      },


      click_password_new() {
        if (this.password_change.password_a != "" && this.password_change.password_a != this.password_change.password_b) {
          this.$alert('Hesla nejsou identická. Opakujte zadání hesla znovu.', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true
            });
            return false;
        } else {
          this.$refs["form_password_new"].validate((valid) => {
            if (valid) {
              this.a_password_change( { new_password: this.password_change.password_a} );
              this.m_modal_password_change(false);
              this.m_modal_password_new(false);
              // this.password_change.password_a = "";
              // this.password_change.password_b = "";
            } else {
              this.$message({ type: 'error', message: 'Formulář nelze odeslat, ověřte položky!' });
              return false;
            }
          });
        }
      },


      open_modal_help() {
        this.m_modal_help(true);
      },


      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },

      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },

      handleSelectApplication(key, keyPath) {
        this.m_app(keyPath[0]);
      },


      handleScroll() {
        let scrollValue = document.body.scrollTop || document.documentElement.scrollTop;
        this.currentScrollValue = scrollValue;
        if (scrollValue > 200) {
          this.navbarTransparent = false;
        } else {
          this.navbarTransparent = true;
        }
      },


      scrollListener() {
        resizeThrottler(this.handleScroll);
      },

      collapshelp(val) {
        console.log(val);
      },

    },



    beforeCreate () {
    },

    created () {
    },

    beforeMount () {
    },

    mounted () {
      document.addEventListener("scroll", this.scrollListener);
    },

    beforeUpdate () {
    },

    updated () {
    },

    beforeDestroy() {
      document.removeEventListener("scroll", this.scrollListener);
    },

    afterDestroy () {
    },

    destroyed () {
    },


  }

</script>

<style>

navbar{
  background-color: #333 !important;
}

el-select {
  margin-left: 25px !important;
  margin-right: 25px !important;
}

.select-warning.el-select .el-input input {
  border-radius: 0px !important;
  color: gray !important;
  background-color: white !important;
}

.app_name {
  font-size: 50px !important;
  font-weight: 900 !important;
  line-height: 0.80;
  text-align: center !important;
  margin-top: 40px !important;
  color: white !important;
}

.app_name_small {
  font-size: 18px !important;
  line-height: 1.00;
  font-weight: 600 !important;
  color: white !important;
}

.dolu_subject {
  padding-top: 6px !important;
}

.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {
  color: white !important;
}

.navbar.navbar-transparent {
  border-bottom: 0 !important;
}

.hlp .el-collapse-item__header {
  color: rgb(51, 136, 69);
  font-size: 16px;
  font-weight: 800 !important;
}

</style>
